export default "__VITE_ASSET__C_uQi8TD__"